'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tool = require('../../common/tool');

var _tool2 = _interopRequireDefault(_tool);

var _request = require('../../common/request');

var _request2 = _interopRequireDefault(_request);

var _config = require('../../common/config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contactMain = /** @class */function () {
    function contactMain() {
        this.contactDom = document.getElementById('contact');
        // 网络请求
        this.wmRequest = new _request2.default();
        this.init();
    }
    contactMain.prototype.init = function () {
        this.handleSubmit();
    };
    contactMain.prototype.handleSubmit = function () {
        var that = this;
        var submitBtn = _tool2.default.$_select(that.contactDom, '.submit-btn');
        submitBtn.addEventListener('click', function () {
            var inputNameDom = _tool2.default.$_select(that.contactDom, '.form-name');
            var inputEmailDom = _tool2.default.$_select(that.contactDom, '.form-email');
            var textareaDom = _tool2.default.$_select(that.contactDom, '.form-textarea');
            var inputName = inputNameDom.value.trim();
            var inputEmail = inputEmailDom.value.trim();
            var textareaVal = textareaDom.value.trim();
            // 校验
            if (inputName == '') {
                alert('The nickname is empty.');
                return;
            }
            if (inputEmail == '') {
                alert('E-mail address is empty');
                return;
            } else if (inputEmail != '') {
                var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
                if (!reg.test(inputEmail)) {
                    alert('E-mail address is wrong');
                    return;
                }
            }
            if (textareaVal == '') {
                alert('Feedback content is empty');
                return;
            }
            that.wmRequest.ajax({
                type: 'POST',
                url: _config2.default.WM_CONTACT,
                data: {
                    nickname: inputName,
                    email: inputEmail,
                    content: textareaVal
                }
            }).then(function (res) {
                if (res.code == 200) {
                    var contactContentDom = _tool2.default.$_selectAll(that.contactDom, '.contact-style');
                    contactContentDom.forEach(function (item) {
                        item.classList.remove('show');
                        var successBox = _tool2.default.$_select(that.contactDom, '.success-box');
                        successBox.classList.add('show');
                    });
                }
            });
        });
    };
    return contactMain;
}();
exports.default = contactMain;